import request from '@/utils/request'

// 分页获取我的医生列表
export function getMyDoctPageList (data) {
    return request({
        url: '/api/doctor/myDoctPageList',
        method: 'get',
        params: data,
    })
}

// 根据用户id查询用户信息
export function getMemberDetail (data) {
    return request({
        url: '/api/member/get',
        method: 'get',
        params: data,
    })
}

// 修改个人信息
export function editMember (data) {
    return request({
        url: '/api/member/edit',
        method: 'POST',
        data,
    })
}

/**
 * 绑卡电子健康卡
 * @param queryType==1 正常绑定
 * @param queryType==2 快速绑定
 */
export function fastRecord (data) {
    return request({
        url: '/api/record/add',
        method: 'POST',
        data,
    })
}
// 解绑电子健康卡
export function deleteRecord (data) {
    return request({
        url: '/api/record/delete/hnCode',
        method: 'POST',
        data,
    })
}

// 获取民族数组
export function getNations (data) {
    return request({
        url: '/api/dict?type=NATION_TYPE',
        method: 'get',
    })
}

// 获取挂号记录
export function getOrderReserve (data) {
    return request({
        url: '/api/order/reserve',
        method: 'get',
        params: data,
    })
}

// 查询消息列表
export function getMsgList (data) {
    return request({
        url: '/api/messages/getList',
        method: 'get',
        params: data,
    })
}

// 消息改全部变为已读（隐藏）
export function hideMsgList (data) {
    return request({
        url: '/api/messages/state',
        method: 'get',
        params: data,
    })
}

// 查询未读消息数量
export function getUnreadList (data) {
    return request({
        url: '/api/messages/getUnreadList',
        method: 'get',
        params: data,
    })
}


// 获取微信扫码登录信息
export function webWxLink () {
    return request({
        url: '/api/third-login/webWxLink',
        method: 'post'
    })
}

// 获取支付宝扫码登录信息
export function webZfbLink () {
    return request({
        url: '/api/third-login/webZfbLink',
        method: 'post'
    })
}



//问卷调查
export function getVotePage (data) {
    return request({
        url: '/api/vote/page',
        method: 'get',
        params: data,
    })
}

//获取已填写的问卷调查
export function getPage (data) {
    return request({
        url: '/api/vote/answer/page',
        method: 'get',
        params: data,
    })
}

// 根据id获取问卷调查
export function vote (data) {
    return request({
        url: '/api/vote/' + data,
        method: 'get',
    })
}


//  问卷调查结果上传 第一步
export function saveVoteSubmit (data) {
    return request({
        url: '/api/vote/save/submit',
        method: 'post',
        data
    })
}



//  问卷调查结果上传 第二步
export function saveVoteItem (data) {
    return request({
        url: '/api/vote/save/item',
        method: 'post',
        data
    })
}

//  获取绑定信息
export function getBindInfo (data) {
    return request({
        url: '/api/third-login/getBindInfo/' + data,
        method: 'get'
    })
}

//  解除绑定信息
export function delBind (data) {
    return request({
        url: '/api/third-login/delBind/' + data,
        method: 'get'
    })
}




// 获取我关注的医院
export function myFavoriteHospList (data) {
    return request({
        url: '/api/hospital/myFavoriteHospList',
        method: 'get',
        params: data,
    })
}


// 获取我关注的科室
export function myFavoriteDepartment (data) {
    return request({
        url: '/api/dept/myFavoriteDeptList',
        method: 'get',
        params: data,
    })
}

// 获取我关注的疾病
export function myFavoriteDiseaseList (data) {
    return request({
        url: '/api/disease-type/myFavoriteDiseaseList',
        method: 'get',
        params: data,
    })
}

// 获取自建病例/检测列表 业务类型(1:自建病例,2:自建检测)
export function getRecordList (caseType) {
  return request({
      url: `/api/oneselfCaseRecord/getRecordList/${caseType}`,
      method: 'get',
      params: null,
  })
}

// 保存自建病例/检测列表
export function saveRecord (data) {
  return request({
      url: '/api/oneselfCaseRecord/saveRecord',
      method: 'post',
      data
  })
}
